import React from 'react';
const rows = [{
  label: 'Domingos de Ansiedad',
  before: 'Buscando qué enseñar el lunes para no improvisar frente a tus alumnos.',
  after: 'Planificación Express: todo el año resuelto en 2 clics.'
}, {
  label: 'Crear Ejercicios',
  before: 'Horas diseñando fichas que a veces ni siquiera funcionan en clase.',
  after: 'Material de Élite: miles de ejercicios probados y listos para imprimir.'
}, {
  label: 'Diseñar Evaluaciones',
  before: 'Sufrir redactando exámenes nuevos por cada unidad temática.',
  after: 'Evaluaciones Listas: pruebas prediseñadas con sus solucionarios.'
}, {
  label: 'Agotamiento Docente',
  before: 'Llegas al aula cansado de tanto organizar la noche anterior.',
  after: 'Energía Máxima: cero estrés. Llegas listo para conectar con tus niños.'
}];
const bottomStats = [{
  num: '+150h',
  label: 'Ahorradas al año'
}, {
  num: '2 clics',
  label: 'Para cada clase lista'
}, {
  num: '1.º a 6.º',
  label: 'Primaria completa'
}];
export function ContrastSection() {
  return <section className="w-full bg-bg-main py-20 px-4" data-id="element-68">
      <div className="max-w-4xl mx-auto" data-id="element-69">
        {/* Section header */}
        <div className="text-center mb-12" data-id="element-70">
          <p className="text-primary font-bold uppercase tracking-wider text-xs sm:text-sm mb-3" data-id="element-71">
            ⚡ La Transformación
          </p>
          <h2 className="text-3xl sm:text-5xl font-black text-text-main mb-4 tracking-tight" data-id="element-72">
            Tu planificación de Matemáticas{' '}
            <span className="text-primary" data-id="element-73">en 2 clics</span>.
          </h2>
          <p className="text-text-sec text-base sm:text-lg max-w-2xl mx-auto" data-id="element-74">
            Esto es lo que cambia desde la primera semana con MegaPack
            Matemática Lista™ en tus manos.
          </p>
        </div>

        {/* Time cost callout */}
        <div className="bg-badge-red/10 border border-badge-red/20 rounded-2xl p-6 sm:p-8 mb-12 text-center" data-id="element-75">
          <p className="text-badge-red font-black text-2xl sm:text-3xl mb-2" data-id="element-76">
            150+ horas / año
          </p>
          <p className="text-text-main text-base sm:text-lg font-medium leading-relaxed" data-id="element-77">
            <span className="text-badge-red font-bold" data-id="element-78">
              ¿Cuánto vale tu descanso?
            </span>{' '}
            Planificar manualmente para todos tus grados de Básica / Primaria te
            quita 3 a 5 horas por semana — el equivalente a un{' '}
            <span className="text-badge-red font-black" data-id="element-79">
              mes entero de trabajo al año
            </span>{' '}
            quemado en fichas, dibujos y dudas mentales.
          </p>
        </div>

        <div className="bg-bg-alt rounded-2xl shadow-2xl border border-border-light overflow-hidden mb-10" data-id="element-80">
          {/* Header */}
          <div className="grid grid-cols-1 md:grid-cols-2 border-b border-border-light bg-primary/5" data-id="element-81">
            <div className="px-6 py-5 font-bold text-badge-red text-center md:text-left border-b md:border-b-0 md:border-r border-border-light tracking-wider text-sm" data-id="element-82">
              TU RUTINA ANTES DEL KIT
            </div>
            <div className="px-6 py-5 font-black text-primary text-center md:text-left tracking-wider text-sm" data-id="element-83">
              TU VIDA CON MATEMÁTICA LISTA
            </div>
          </div>

          {/* Rows */}
          <div className="divide-y divide-border-light" data-id="element-84">
            {rows.map((row, i) => <div key={i} className="grid grid-cols-1 md:grid-cols-2 group hover:bg-primary/[0.02] transition-colors" data-id="element-85">
                <div className="px-6 py-6 flex items-start gap-4 border-b md:border-b-0 md:border-r border-border-light bg-badge-red/5" data-id="element-86">
                  <div className="w-6 h-6 rounded-full bg-badge-red/20 flex items-center justify-center flex-shrink-0 mt-0.5 border border-badge-red/30" data-id="element-87">
                    <span className="text-badge-red font-bold text-sm" data-id="element-88">✕</span>
                  </div>
                  <div data-id="element-89">
                    <p className="text-text-main font-bold text-sm mb-1" data-id="element-90">
                      {row.label}
                    </p>
                    <p className="text-text-sec font-medium" data-id="element-91">{row.before}</p>
                  </div>
                </div>
                <div className="px-6 py-6 flex items-start gap-4 bg-primary/5 relative overflow-hidden" data-id="element-92">
                  <div className="absolute inset-0 bg-gradient-to-r from-primary/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-93"></div>
                  <div className="w-6 h-6 rounded-full bg-check-green/20 flex items-center justify-center flex-shrink-0 mt-0.5 border border-check-green/30 relative z-10" data-id="element-94">
                    <span className="text-check-green font-bold text-sm" data-id="element-95">
                      ✓
                    </span>
                  </div>
                  <div className="relative z-10" data-id="element-96">
                    <p className="text-primary font-bold text-sm mb-1" data-id="element-97">
                      {row.label}
                    </p>
                    <p className="text-text-main font-bold" data-id="element-98">{row.after}</p>
                  </div>
                </div>
              </div>)}
          </div>
        </div>

        {/* Bottom stats */}
        <div className="grid grid-cols-3 gap-3 sm:gap-6" data-id="element-99">
          {bottomStats.map((s, i) => <div key={i} className="bg-bg-alt border border-primary/20 rounded-xl p-4 sm:p-6 text-center shadow-sm" data-id="element-100">
              <p className="text-primary font-black text-xl sm:text-3xl mb-1" data-id="element-101">
                {s.num}
              </p>
              <p className="text-text-sec text-xs sm:text-sm leading-snug" data-id="element-102">
                {s.label}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}